import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, mergeProps as _mergeProps, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createBlock as _createBlock, vModelText as _vModelText } from "vue"

const _hoisted_1 = {
  class: "contact-wrapper",
  id: "registrationForm"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "center black" }, "Jelentkezés", -1)
const _hoisted_3 = { class: "form-wrapper contact-form mt-50" }
const _hoisted_4 = {
  key: 0,
  class: "row"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Kérem, válassza ki, hogy céget vagy cégvezetőt szeretne jelölni.")
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "row checkbox-wrapper"
}
const _hoisted_8 = { class: "col-6" }
const _hoisted_9 = { class: "input-wrapper" }
const _hoisted_10 = { class: "table-coll checkbox-wrapper" }
const _hoisted_11 = { class: "checkbox-wrapper" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "checkbox-text" }, "Cég", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "error" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Kérem válasszon")
], -1)
const _hoisted_15 = { class: "col-6" }
const _hoisted_16 = { class: "input-wrapper" }
const _hoisted_17 = { class: "table-coll checkbox-wrapper" }
const _hoisted_18 = { class: "checkbox-wrapper" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "checkbox-text" }, "Cégvezető", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "error" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Kérem válasszon")
], -1)
const _hoisted_22 = {
  key: 2,
  class: "row"
}
const _hoisted_23 = { class: "col-12" }
const _hoisted_24 = { class: "input-wrapper" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Keresés: ")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Kezdje el gépelni a cég nevét (min. 3 karaktert)")
const _hoisted_27 = {
  slot: "option",
  "slot-scope": "option"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "error" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Megadása kötelező")
], -1)
const _hoisted_29 = {
  key: 3,
  class: "row"
}
const _hoisted_30 = { class: "col-12" }
const _hoisted_31 = { class: "input-wrapper" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "error" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Megadása kötelező")
], -1)
const _hoisted_33 = { class: "row" }
const _hoisted_34 = { class: "col-12" }
const _hoisted_35 = { class: "input-wrapper" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "error" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Megadása kötelező")
], -1)
const _hoisted_37 = { class: "row" }
const _hoisted_38 = { class: "col-12" }
const _hoisted_39 = { class: "input-wrapper" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "error" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Kapcsolattartó neve")
], -1)
const _hoisted_41 = { class: "row" }
const _hoisted_42 = { class: "col-6" }
const _hoisted_43 = { class: "input-wrapper" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "error" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Megadása kötelező")
], -1)
const _hoisted_45 = { class: "col-6" }
const _hoisted_46 = { class: "input-wrapper" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "error" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Megadása kötelező")
], -1)
const _hoisted_48 = { class: "row" }
const _hoisted_49 = { class: "col-12" }
const _hoisted_50 = { class: "input-wrapper" }
const _hoisted_51 = { class: "counter" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("p", { class: "italic" }, "A jelölésre vonatkozó pályázatát röviden alátámaszthatja indoklással, illetve cégvezető jelölése esetében, amennyiben megoldható, kérjük, küldje meg a jelölt Linkedin profilját. ", -1)
const _hoisted_53 = { class: "row mt-50" }
const _hoisted_54 = { class: "col-12" }
const _hoisted_55 = { class: "input-wrapper" }
const _hoisted_56 = { class: "table-coll checkbox-wrapper" }
const _hoisted_57 = { class: "checkbox-wrapper" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("span", { class: "checkbox-text" }, [
  /*#__PURE__*/_createTextVNode("Elolvastam és elfogadom az "),
  /*#__PURE__*/_createElementVNode("a", { href: "" }, "adatvédelmi nyilatkozatot.")
], -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "error" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Adatvédelmi nyilatkozat elfogadása kötelező")
], -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "input-wrapper center" }, [
      /*#__PURE__*/_createElementVNode("button", { class: "btn primary" }, "Jelentkezés elküldése")
    ])
  ])
], -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "input-wrapper center" }, [
      /*#__PURE__*/_createElementVNode("h1", { class: "center black" }, "Köszönjük üzenetét!")
    ])
  ])
], -1)
const _hoisted_63 = { class: "form-wrapper contact-form mt-50" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "input-wrapper center" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "center" }, " Munkatársunk hamarosan felveszi Önnel a kapcsolatot.")
    ])
  ])
], -1)
const _hoisted_65 = { class: "row" }
const _hoisted_66 = { class: "col-12" }
const _hoisted_67 = { class: "input-wrapper center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_templete = _resolveComponent("templete")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isSent)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Form, {
              onSubmit: _ctx.send,
              "validation-schema": _ctx.schema
            }, {
              default: _withCtx(() => [
                (!_ctx.isLifetimeAwards)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
                  : _createCommentVNode("", true),
                (!_ctx.isLifetimeAwards)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_component_Field, {
                            name: "is_company",
                            type: "checkbox",
                            modelValue: _ctx.is_company,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.is_company) = $event))
                          }, {
                            default: _withCtx(({is_company_slot}) => [
                              _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("label", _hoisted_11, [
                                  _withDirectives(_createElementVNode("input", _mergeProps({ type: "checkbox" }, is_company_slot, {
                                    name: "is_company",
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.is_company) = $event))
                                  }), null, 16), [
                                    [_vModelCheckbox, _ctx.is_company]
                                  ]),
                                  _hoisted_12,
                                  _hoisted_13
                                ])
                              ])
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, { name: "is_company" }, {
                            default: _withCtx(() => [
                              _hoisted_14
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_component_Field, {
                            name: "is_manager",
                            type: "checkbox",
                            modelValue: _ctx.is_manager,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.is_manager) = $event))
                          }, {
                            default: _withCtx(({is_manager_slot}) => [
                              _createElementVNode("div", _hoisted_17, [
                                _createElementVNode("label", _hoisted_18, [
                                  _withDirectives(_createElementVNode("input", _mergeProps({ type: "checkbox" }, is_manager_slot, {
                                    name: "is_manager",
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.is_manager) = $event))
                                  }), null, 16), [
                                    [_vModelCheckbox, _ctx.is_manager]
                                  ]),
                                  _hoisted_19,
                                  _hoisted_20
                                ])
                              ])
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, { name: "is_manager" }, {
                            default: _withCtx(() => [
                              _hoisted_21
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.is_company)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createVNode(_component_v_select, {
                            options: _ctx.company,
                            label: "Name",
                            placeholder: "Cég név",
                            modelValue: _ctx.selectedCompany,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedCompany) = $event)),
                            onSearch: _ctx.fetchOptions
                          }, {
                            "no-options": _withCtx(({ search, searching, loading }) => [
                              searching
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (_ctx.getIsLoading)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _hoisted_25,
                                          _createElementVNode("em", null, _toDisplayString(search), 1)
                                        ], 64))
                                      : (_openBlock(), _createBlock(_component_templete, { key: 1 }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("A keresés nem hozott találatot ( " + _toDisplayString(search) + " )", 1)
                                          ]),
                                          _: 2
                                        }, 1024))
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _hoisted_26
                                  ], 64))
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("template", _hoisted_27, [
                                _createTextVNode(_toDisplayString(_ctx.option.name), 1)
                              ])
                            ]),
                            _: 1
                          }, 8, ["options", "modelValue", "onSearch"]),
                          _createVNode(_component_Field, {
                            class: "form-control disabled",
                            name: "selectedCompany",
                            modelValue: _ctx.selectedCompany,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedCompany) = $event)),
                            style: {"display":"none"}
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, { name: "selectedCompany" }, {
                            default: _withCtx(() => [
                              _hoisted_28
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.is_manager)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _createVNode(_component_Field, {
                            name: "manager",
                            placeholder: "Cégvezető neve",
                            modelValue: _ctx.manager,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.manager) = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, { name: "manager" }, {
                            default: _withCtx(() => [
                              _hoisted_32
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createVNode(_component_v_select, {
                        multiple: "",
                        options: _ctx.awards,
                        label: "name",
                        placeholder: "Díjátadó neve",
                        modelValue: _ctx.selectedAwards,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedAwards) = $event))
                      }, null, 8, ["options", "modelValue"]),
                      _createVNode(_component_Field, {
                        class: "form-control disabled",
                        name: "selectedAwards",
                        modelValue: _ctx.selectedAwards,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedAwards) = $event)),
                        style: {"display":"none"}
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, { name: "selectedAwards" }, {
                        default: _withCtx(() => [
                          _hoisted_36
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _createVNode(_component_Field, {
                        name: "contact_name",
                        placeholder: "Kapcsolattartó neve",
                        modelValue: _ctx.contact_name,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.contact_name) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, { name: "contact_name" }, {
                        default: _withCtx(() => [
                          _hoisted_40
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                      _createVNode(_component_Field, {
                        name: "contact_email",
                        placeholder: "E-mail cím",
                        modelValue: _ctx.contact_email,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.contact_email) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, { name: "contact_email" }, {
                        default: _withCtx(() => [
                          _hoisted_44
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _createVNode(_component_Field, {
                        name: "contact_phone",
                        placeholder: "Telefonszám",
                        modelValue: _ctx.contact_phone,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.contact_phone) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, { name: "contact_phone" }, {
                        default: _withCtx(() => [
                          _hoisted_47
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, [
                      _withDirectives(_createElementVNode("textarea", {
                        name: "motivation",
                        placeholder: "Indoklás",
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.motivation) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.motivation]
                      ]),
                      _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.motivation ? _ctx.motivation.length : 0) + " / 500 ", 1),
                      _hoisted_52
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("div", _hoisted_55, [
                      _createVNode(_component_Field, {
                        name: "terms",
                        type: "checkbox",
                        modelValue: _ctx.legal_statement,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.legal_statement) = $event))
                      }, {
                        default: _withCtx(({terms1}) => [
                          _createElementVNode("div", _hoisted_56, [
                            _createElementVNode("label", _hoisted_57, [
                              _withDirectives(_createElementVNode("input", _mergeProps({ type: "checkbox" }, terms1, {
                                name: "terms",
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.legal_statement) = $event))
                              }), null, 16), [
                                [_vModelCheckbox, _ctx.legal_statement]
                              ]),
                              _hoisted_58,
                              _hoisted_59
                            ])
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, { name: "terms" }, {
                        default: _withCtx(() => [
                          _hoisted_60
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _hoisted_61
              ]),
              _: 1
            }, 8, ["onSubmit", "validation-schema"])
          ])
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.isSent)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _hoisted_62,
          _createElementVNode("div", _hoisted_63, [
            _hoisted_64,
            _createElementVNode("div", _hoisted_65, [
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("div", _hoisted_67, [
                  _createElementVNode("button", {
                    href: "javascript:undefined",
                    class: "btn primary center mt-50 small",
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.back()))
                  }, "Vissza ")
                ])
              ])
            ])
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}